"use strict";
var AddressValidState;
(function (AddressValidState) {
    AddressValidState[AddressValidState["Unverified"] = 0] = "Unverified";
    AddressValidState[AddressValidState["Valid"] = 1] = "Valid";
    AddressValidState[AddressValidState["Invalid"] = 2] = "Invalid";
})(AddressValidState = exports.AddressValidState || (exports.AddressValidState = {}));
//# sourceMappingURL=D:/a/1/s/eligibility/src/models/jurisdictions/address-valid-state.enum.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/models/jurisdictions/address-valid-state.enum.js